import { Home, PlusCircle, Gift, User } from "lucide-react";
import { useVentaModal } from "./VentaModalContext";

type View = string;

interface BottomNavProps {
  view: View;
  setView: (v: View) => void;
  className?: string;
  /** Called before each nav action (e.g. close register-venta sheet on mobile) */
  onNavInteraction?: () => void;
}

const BottomNav = ({
  view,
  setView,
  className = "",
  onNavInteraction,
}: BottomNavProps) => {
  const openVenta = useVentaModal();

  const run = (action: () => void) => {
    onNavInteraction?.();
    action();
  };

  const item = (key: string, label: string, icon: React.ReactNode, onClick: () => void) => {
    const active = view === key;
    return (
      <button
        type="button"
        onClick={() => run(onClick)}
        className={`bn-item flex min-w-0 flex-1 flex-col items-center gap-1 border-0 bg-transparent py-2 text-xs ${
          active ? "text-[#205f43]" : "text-gray-500"
        }`}
      >
        <span
          className={`flex h-9 w-9 items-center justify-center rounded-full ${
            active ? "bg-[#205f43]/15" : "bg-gray-100"
          }`}
        >
          {icon}
        </span>
        <span className="truncate font-medium">{label}</span>
      </button>
    );
  };

  return (
    <nav
      className={`safe-area-pb fixed bottom-0 left-0 right-0 z-40 flex border-t border-gray-200 bg-white/95 py-1 shadow-[0_-4px_20px_rgba(0,0,0,0.06)] backdrop-blur ${className}`}
      role="navigation"
      aria-label="Principal"
    >
      {item("Home", "Inicio", <Home className="h-5 w-5" strokeWidth={2} />, () =>
        setView("Home")
      )}
      {item(
        "__venta__",
        "Venta",
        <PlusCircle className="h-5 w-5" strokeWidth={2} />,
        () => {
          openVenta();
        }
      )}
      {item("Premios", "Premios", <Gift className="h-5 w-5" strokeWidth={2} />, () =>
        setView("Premios")
      )}
      {item("Perfil", "Perfil", <User className="h-5 w-5" strokeWidth={2} />, () =>
        setView("Perfil")
      )}
    </nav>
  );
};

export default BottomNav;
